import type { DictFragment } from "../translations";
export const cde: DictFragment = {
  fr: {
    "cde.title": "Suivi CdE",
    "cde.consultant": "Responsable CdE",
    "cde.delivered": "Version livrée",
    "cde.target": "Version visée",
    "cde.open": "Ouvrir dans le CdE",
    "cde.updated": "Dernier état reçu",
    "cde.stale":
      "Actualisation du CdE attendue ; le dernier état reçu est conservé.",
    "cde.saveFirst":
      "Enregistrer le jalon avec son type Processus avant la transmission.",
    "cde.kind": "Type de demande",
    "cde.new": "Nouveau processus",
    "cde.rework": "Révision d’un processus",
    "cde.process": "Processus",
    "cde.choose": "Choisir le processus en service",
    "cde.retry": "Réessayer la transmission",
    "cde.send": "Confier au CdE",
    "cde.milestoneType": "Type de jalon",
    "cde.standard": "Jalon standard",
    "cde.status.inbox": "Inbox",
    "cde.status.todo": "To Do",
    "cde.status.in_progress": "In Progress",
    "cde.status.done": "Done",
  },
  en: {
    "cde.title": "CdE tracking",
    "cde.consultant": "CdE lead",
    "cde.delivered": "Delivered version",
    "cde.target": "Target version",
    "cde.open": "Open in CdE",
    "cde.updated": "Last status received",
    "cde.stale": "Waiting for a CdE update; the last known status is retained.",
    "cde.saveFirst": "Save the milestone as a Process before handing it over.",
    "cde.kind": "Request type",
    "cde.new": "New process",
    "cde.rework": "Revise a process",
    "cde.process": "Process",
    "cde.choose": "Choose the live process",
    "cde.retry": "Retry handoff",
    "cde.send": "Hand over to CdE",
    "cde.milestoneType": "Milestone type",
    "cde.standard": "Standard milestone",
    "cde.status.inbox": "Inbox",
    "cde.status.todo": "To Do",
    "cde.status.in_progress": "In Progress",
    "cde.status.done": "Done",
  },
};
